import cx from 'classnames';

import { FC } from 'react';
import styles from './Avatar.module.scss';
import { WaitingManSvg } from '@assets/svg';

interface AvatarProps {
  src: string;
  small?: boolean;
  className?: string;
}

export const Avatar: FC<AvatarProps> = ({ src, className, small = false }) => {
  return (
    <div
      className={cx(styles.avatarContainer, className, small && styles.aContainerSmall)}
    >
      {src ? (
        <img width={small ? 28 : 30} height={small ? 28 : 30} alt="avatar" src={src} />
      ) : (
        <div className={cx(styles.avatarDefault, small && styles.avatarDefaultSmall)}>
          <WaitingManSvg width={24} height={25} />
        </div>
      )}

      <img src="/images/AvatarMask.svg" className={styles.avatarMask} alt="AvatarMask" />
    </div>
  );
};
